/**
 * A count of seconds as M:SS. The part under a second is dropped.
 * A caller that rounds or clamps does it first. A value that is not a finite number, or is negative, reads 0:00.
 */
export function formatMinutesSeconds(seconds) {
    const value = Number(seconds);
    if (!Number.isFinite(value) || value < 0) return '0:00';
    const whole = Math.floor(value);

    return Math.floor(whole / 60) + ':' + String(whole % 60).padStart(2, '0');
}
